import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ViewStateService } from '../../services/view-state-service';

@Component({
    selector: 'app-nav-directory',
    templateUrl: './nav-directory.component.html',
    styleUrls: ['./nav-directory.component.scss'],
})
export class NavDirectoryComponent {
    activeTab = 'utilisateurs';
    view: 'list' | 'map' = 'list';
    isExpanded = false;

    dictionary = environment.dictionary;

    organizationDirectoryAvailable = environment.features.organizationDirectoryAvailable;
    public mapView = false;
    public listView = true;

    constructor(private viewStateService: ViewStateService) {}

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    setActiveTab(tab: string): void {
        this.activeTab = tab;
    }

    updateView(view: string): void {
        this.view = view as 'list' | 'map';
        if (view === 'map') {
            this.mapView = true;
            this.listView = false;
        } else {
            this.mapView = false;
            this.listView = true;
        }

        this.viewStateService.changeView(this.view);
    }

    checkActiveTab(): string {
        const currentUrl = window.location.href;

        if (currentUrl.includes('members')) {
            return 'members';
        } else if (currentUrl.includes('organizations')) {
            return 'organizations';
        }

        return this.activeTab;
    }
}
